module.exports = __webpack_public_path__ + "img/diorAddict1.4822fbe0.jpg";